module.exports = __webpack_public_path__ + "static/media/wenhao2.f8fbe3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wenhao2.png
// module id = 1868
// module chunks = 0 1